import actions from './actions';

let initState = {
    adminDashboardLoader: false,
    adminDashboardDetails: '',
    adminDashboardError: ''
};

export default function adminDashboardReducer(state = initState, action) {
    switch (action.type) {
        case actions.ADMIN_DASHBOARD_START: {
            return {
                ...state,
                adminDashboardLoader: true
            };
        }
        case actions.ADMIN_DASHBOARD_SUCCESS: {
            return {
                ...state,
                adminDashboardLoader: false,
                adminDashboardDetails: action.payload
            };
        }
        case actions.ADMIN_DASHBOARD_FAILURE: {
            return {
                ...state,
                adminDashboardLoader: false,
                adminDashboardError: action.payload
            };
        }
        default:
            return state;
    }
}

